var _templateObject = _taggedTemplateLiteralLoose(['\n  padding: 24px;\n  max-width: 680px;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: calc(100vh - 300px);\n  @media (max-width: 768px) {\n    padding: 12px;\n    min-height: 0;\n  }\n'], ['\n  padding: 24px;\n  max-width: 680px;\n  margin-left: auto;\n  margin-right: auto;\n  min-height: calc(100vh - 300px);\n  @media (max-width: 768px) {\n    padding: 12px;\n    min-height: 0;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
var Container = styled.div(_templateObject);

var AppContainer = function AppContainer(props) {
  return React.createElement(Container, null, props.children);
};

export default AppContainer;